// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"471":"0d283fcc","854":"3f23d166"}[chunkId] + ".chunk.js";
};